export class UTMSourceDTO {
    constructor(
        public source: string,
        public colour: string
    ) { }
}

export class DiaryPreferencesDTO {

    constructor(
        public confirmAddBooking: boolean,
        public merchantBookingsRequireChargeByDefault: boolean,
        public merchantRequiresCancellationReason: boolean | null,
        public pendingPaymentExpiryMinutes: number | null,
        public utmSources: UTMSourceDTO[],
        public switchToSMS: boolean,
        public requireUserPinCode: boolean,
        public hideClosedBookingSlots: boolean,
        public customerFirstNameRequired = false,
        public customerLastNameRequired = false,
        public customerEmailAddressRequired = false,
        public customerPhoneNumberRequired = false,
    ) { }
}
